import { Control } from "../../business-objects/control/control.model";
import { DateTimeControlConfig } from "./date-time-control-config.model";

export class DateTimeControl extends Control {
    config: DateTimeControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/datetime/date-time-control.model.ts